import logger from '@/layers/support/monitoring/logger';
import { UserType } from '@/types/modelEnums';
import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useGlobalState } from '../context/GlobalStateContext';

const LOG_MODULE = 'FE [Presentation / Hooks / useProfileCompletionCheck]';

/**
 * Hook to manage provider profile completion checking.
 * This will force the profile completion modal to show when needed.
 *
 * @param forceCheck If true, the hook will trigger the check regardless of the current state
 * @returns an object with the showProfileCompletion flag
 */
export function useProfileCompletionCheck(forceCheck = false) {
  const { needsProviderProfileCompletion, refreshProfile } = useAuth();
  const { profile } = useGlobalState();
  const [showProfileCompletion, setShowProfileCompletion] = useState(false);

  const isProviderUser = profile?.type === UserType.PROVIDER;

  useEffect(() => {
    // If we're forcing a check on this page or needsProviderProfileCompletion is true,
    // and the user is a provider, set the flag to show the completion modal
    if (isProviderUser && (forceCheck || needsProviderProfileCompletion)) {
      logger.debug(`${LOG_MODULE} Setting showProfileCompletion to true`, {
        forceCheck,
        needsProviderProfileCompletion,
      });
      setShowProfileCompletion(true);
    } else {
      setShowProfileCompletion(false);
    }
  }, [forceCheck, needsProviderProfileCompletion, isProviderUser]);

  return {
    showProfileCompletion,
    refreshProfile,
  };
}
